import React from 'react'
import classNames from 'classnames'

import Avatar from 'components/Utils/Avatar'
import IconButton from 'components/Utils/IconButton'

export default React.memo(function OrganizationDropdownButton({
  organization,
}) {
  return (
    <div
      className={classNames([
        'flexbox flexbox-align-center',
        'pointer transition',
        'radius-small',
        'background-shade-50-on-hover',
      ])}
    >
      <IconButton>
        <Avatar
          borderClass="border-none"
          size="small"
          name={organization.name}
          url={organization.photoURL}
        />
      </IconButton>
    </div>
  )
})
